define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var AppConfig = require('config/application');
    var LPTModel = require('vendor/Backbone/LPTModel');

    return LPTModel.extend({

        url: '/server/?action=getUserProfile',

        //initialize: function (options) {
        //    if (!options) {
        //        this.getLocalData();
        //    }
        //    this.on('change', this.setLocalData, this);
        //},
        //
        //getLocalData: function() {
        //    var data = JSON.parse(localStorage.getItem('user')) || {};
        //    this.set(data, {silent: true});
        //},
        //
        //setLocalData: function() {
        //    localStorage.setItem('user', JSON.stringify(this.toJSON()));
        //}
    });
});
